import Navbar from 'components/Navbar';
import GlobalNavbar from 'components/Navbar/GlobalNavbar';
import TestResultsVisualizer from 'components/TestResultsVisualizer';
import TestSentenceVisualizerV2 from 'components/TestSentenceVisualizerV2';
import React from 'react';
import { useParams } from 'react-router-dom';

const GlobalTestPage: React.FC = () => {
  const domain = useParams<{ customerDomain: string }>().customerDomain;

  return (
    <div className="min-h-screen min-w-screen bg-white">
      {domain ? <Navbar /> : <GlobalNavbar />}
      <div className="flex flex-col gap-4 py-10 min-h-wo-navbar">
        <header>
          <div className="flex flex-row px-6">
            <h2 className="text-heading-1">Test Sentence Visualizer</h2>
          </div>
        </header>
        <main>
          <div className="px-6 flex flex-col gap-8">
            <TestSentenceVisualizerV2 />
            <TestResultsVisualizer annotationBasePath="/global/identifier" blockHighlights />
          </div>
        </main>
      </div>
    </div>
  );
};

export default GlobalTestPage;
